module.exports = __webpack_public_path__ + "img/banner-2.76873098.jpg";